/* eslint-disable no-param-reassign,radix */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSnowflakeDestinationComponent', [
    'DesignerBaseDatabaseDestinationComponent',

    function (DesignerBaseDatabaseDestinationComponent) {
      function DesignerSnowflakeDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);

        this.warehouse = null;
        this.database = null;
        this.max_errors = null;
        this.truncate_columns = null;
      }

      DesignerSnowflakeDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerSnowflakeDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          warehouse: this.warehouse || this.defaults.warehouse,
          database: this.database || this.defaults.database,
          max_errors: this.max_errors || this.defaults.max_errors,
          truncate_columns: angular.isDefined(this.truncate_columns)
            ? this.truncate_columns
            : this.defaults.truncate_columns,
        });

        return data;
      };

      DesignerSnowflakeDestinationComponent.prototype.getFormData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerSnowflakeDestinationComponent.prototype.setFormData = function (data) {
        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerSnowflakeDestinationComponent.prototype.setData = function (data) {
        if (!angular.isNumber(data.max_errors)) {
          data.max_errors = parseInt(data.max_errors) || 0;
        }

        this.warehouse = data.warehouse;
        this.database = data.database;
        this.max_errors = data.max_errors;
        this.truncate_columns = data.truncate_columns;

        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerSnowflakeDestinationComponent.prototype.getSchema = function () {
        const schema = DesignerBaseDatabaseDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerSnowflakeDestinationComponent;
    },
  ]);
})(window.angular);
